export default {
  metricsWithMetricTabs: undefined,
};
